<template>
    <vue-dropzone ref="dropzone" :id="id" :options="dropzoneOptions" @vdropzone-file-added="onFileAdded"
                  @vdropzone-removed-file="onRemoved" class="custom-dropzone"
    >
        <div class="dz-message text-center">{{ message }}</div>
    </vue-dropzone>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        name: 'DropzoneFileUploader',
        components: {
            vueDropzone: vue2Dropzone
        },
        props: {
            id: {
                type: String,
                default: 'dropzone-uploader'
            },
            acceptedFiles: {
                type: String,
                default: '.csv,.xlsx,.xls'
            },
            maxFiles: {
                type: Number,
                default: 1
            },
            maxFilesize: {
                type: Number,
                default: 10
            },
            message: {
                type: String,
                default: 'Arrastra el archivo aquí o haz clic para subir.'
            },
            removeFileMessage: {
                type: String,
                default: 'Eliminar archivo'
            }
        },
        computed: {
            dropzoneOptions() {
                return {
                    url: 'https://httpbin.org/post',
                    autoProcessQueue: false, 
                    acceptedFiles: this.acceptedFiles,
                    maxFiles: this.maxFiles,
                    maxFilesize: this.maxFilesize,
                    addRemoveLinks: true,
                    dictDefaultMessage: this.message,
                    dictRemoveFile: this.removeFileMessage,
                    thumbnailWidth: 150,
                    thumbnailHeight: 150,
                    createImageThumbnails: false, 
                }
            }
        },
        methods: {
            onFileAdded(file) {
                const nativeFile = file.file || file;
                this.$emit('file-added', nativeFile);
                setTimeout(() => {
                    file.status = "success";
                    if (this.$refs.dropzone && this.$refs.dropzone.dropzone) {
                        this.$refs.dropzone.dropzone.emit("success", file);
                        this.$refs.dropzone.dropzone.emit("complete", file);
                    }
                }, 10);
            },
            onRemoved(file) {
                this.$emit('removed'); 
            },
            removeAllFiles() {
                if (this.$refs.dropzone && this.$refs.dropzone.dropzone) {
                    this.$refs.dropzone.dropzone.removeAllFiles(true);
                }
            }
        }
    }
</script>

<style>
.custom-dropzone {
    border: 2px dashed #007BFF !important;
    border-radius: 5px;
    background: white;
    transition: all 0.3s ease;
}

.custom-dropzone .dz-message {
    font-weight: 500;
    color: #6c757d;
    padding: 2.5rem 0;
    width: 100%;
    text-align: center !important;
}

.custom-dropzone:hover {
    border-color: #0056b3 !important;
    background-color: #f8f9fa;
}

.custom-dropzone .dz-preview {
    margin: 1rem;
}

.custom-dropzone .dz-preview .dz-image {
    border-radius: 5px;
}

.custom-dropzone .dz-preview .dz-details {
    padding: 1rem;
}

.custom-dropzone .dz-preview .dz-success-mark,
.custom-dropzone .dz-preview .dz-error-mark {
    margin-top: -25px;
}

/* Estilo para el estado de éxito */
.custom-dropzone .dz-preview.dz-success .dz-success-mark {
    opacity: 1;
}

/* Estilo para el estado de error */
.custom-dropzone .dz-preview.dz-error .dz-error-mark {
    opacity: 1;
}
</style>